import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import { Flex, Divider, Text, Heading, View, Button} from '@aws-amplify/ui-react';
//import Loading from '../components/loading';
import Loadingmini from '../components/loadingmini';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { withFleets } from '../withFleets';

export default function Alerts({userJwt, refreshJwt, fleetCodes}) {
    const [is_loading, updateIsLoading] = React.useState(false);
    const [count, setCount] = useState(0);
    const [res, updateRes] = useState({status:"Contact support if this message stays for more than 30 seconds",alerts:[]})

    const fleetFilterKey = Array.isArray(fleetCodes) ? fleetCodes.join(',') : '';

    const columns = [
        {
            field: 'region',
            filter: true,
            width: 120
        },
        {
            field: 'topic',
            filter: true,
            width: 400
        },
        {
            field: 'msg',
            filter: true,
            width: 400
        },
        {
            field: 'timestamp',
            filter: true
        },
        {
            headerName: 'Reservation',
            width: 180,
            field: 'res_id',
            filter: true,
            cellRenderer: params => {
                let val = params.value
                let link = withFleets('/reservation/' + String(val), fleetCodes) 
                return( <NavLink to={link} index = {val}>{val}</NavLink>)
            }
        },
        {
            headerName: 'Driver Link',
            width: 75,
            field: 'driver_id',
            filter: true,
            cellRenderer: params => {
                let val = params.value
                let link = withFleets('/user/' + String(val), fleetCodes) 
                return( <NavLink to={link} index = {val}>{val}</NavLink>)
            }
        },
        {
            headerName: 'Driver Name',
            field: 'driver_name',
            filter: true
        },
        {
            headerName: 'Vehicle Link',
            width: 75,
            field: 'car_id',
            filter: true,
            cellRenderer: params => {
                let val = params.value
                let link = withFleets('/vehicle/' + String(val), fleetCodes) 
                return( <NavLink to={link} index = {val}>{val}</NavLink>)
            }
        },
        {
            headerName: 'Vehicle Name',
            field: 'car_name',
            filter: true
        },
        {
            field: 'fleet_code',
            filter: true
        },
    ];


    async function fetchPageData() {
        updateIsLoading(true)
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": userJwt,
            "api_endpoint": "api3:staff:alerts"
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            let next = res
            if (res && Array.isArray(res.alerts) && Array.isArray(fleetCodes) && fleetCodes.length > 0) {
                const allow = new Set(fleetCodes.map((f) => String(f).toUpperCase()))
                next = {
                    ...res,
                    alerts: res.alerts.filter((a) => allow.has(String(a?.fleet_code || '').toUpperCase())),
                }
            }
            updateRes(next)
            if('detail' in res)
            {
                if(res['detail'].includes("token"))
                {
                    refreshJwt()
                }
            }
            updateIsLoading(false)
        }
        catch (e) {
            if(typeof(e) !== 'undefined')
            {
                console.log('error: '+toString(e));
            } else {
                console.log('error - unknown error');
            }
            if(typeof(e.response.status) !== 'undefined')
            {
                if(e.response.status === 401)
                {
                    refreshJwt()
                }
            }
            updateIsLoading(false)
        }
    }

    useEffect(() => {
        fetchPageData()
    },[count, userJwt, fleetFilterKey])
    
//,Auth.currentSession()


  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            <Flex 
                direction='column'
            >
                <Heading level={1}>Critical Alerts</Heading>
                <Text style={{width:'100%'}}>
                  These are time-sensitive, critical alerts that require your attention.
                  {fleetFilterKey ? ` Showing fleet${fleetCodes.length > 1 ? 's' : ''}: ${fleetFilterKey}.` : ''}
                </Text>
                <View>
                    <Button onClick={() => setCount(count + 1)}>
                        PRESS TO GET LATEST UPDATES
                    </Button>
                </View>
                <Flex direction="column" style={{width:"80vw",maxWidth:"2200px"}}>
                    <Divider />
                    <View 
                        theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                        style={{ height: 500 }} // the grid will fill the size of the parent container
                    >
                        {
                            is_loading ? <Loadingmini /> : 
                            !res ? <Text>You have no unread alerts</Text> :
                            !res.alerts ? <Text>You have no unread alerts</Text> :
                            res.alerts.length > 0 === false ? <Text>You have no unread alerts</Text> :
                                <AgGridReact
                                    rowData={res.alerts}
                                    columnDefs={columns}
                                    rowSelection={multiRowSelection}
                                    paginationPageSize={500}
                                    paginationPageSizeSelector={[10, 25, 50]}
                                    enableCellTextSelection={true}
                                />
                        }
                    </View>
                </Flex>
            </Flex>
        </View>
      </Flex>
  );
}
